import { SwitchEntityModal } from '../../Modals/SwitchEntityModal/SwitchEntityModal';
import { NewEntityModal } from '../../Modals/NewEntityModal/NewEntityModal';
import { OrganizationWithWorkspaces } from '@/types/Organization';
import { Dispatch, SetStateAction } from 'react';
import { ModalsReducerPayload, ModalsReducerState } from '@/types/reducers';
import { PermissionFromStore } from '@/types/types';

interface WorkspaceModalsProps {
  isOpen: ModalsReducerState;
  localSelectedOrganization: OrganizationWithWorkspaces | null;
  setLocalSelectedOrganization: Dispatch<
    SetStateAction<OrganizationWithWorkspaces | null>
  >;
  handleOpenNewWorkspaceModal: () => void;
  handleCloseModal: () => void;
  closeModal: (modal: ModalsReducerPayload) => void;
  localOrganizationPermission: PermissionFromStore | null;
}

export const WorkspaceModals = ({
  isOpen,
  localSelectedOrganization,
  setLocalSelectedOrganization,
  handleOpenNewWorkspaceModal,
  handleCloseModal,
  closeModal,
  localOrganizationPermission,
}: WorkspaceModalsProps) => {
  return (
    <>
      <SwitchEntityModal
        externalLocalSelectedOrganization={localSelectedOrganization}
        setExternalLocalSelectedOrganization={setLocalSelectedOrganization}
        handleOpenNewWorkspace={handleOpenNewWorkspaceModal}
        isOpen={isOpen.switchWorkspaceModal}
        setClose={handleCloseModal}
      />
      <NewEntityModal
        organizationWorkspacesNumber={localSelectedOrganization?.workspaces.length || 0}
        organization_max_workspaces={
          localSelectedOrganization?.permissions?.organization_max_workspaces
        }
        organizationId={localSelectedOrganization?.id as string}
        entityType="workspaces"
        isOpen={isOpen.newEntityModal}
        setClose={() => closeModal('newEntityModal')}
        localSelectedOrganization={localSelectedOrganization}
        localSelectedOrganizationPermissions={localOrganizationPermission}
      />
      <NewEntityModal
        entityType="organizations"
        isOpen={isOpen.newOrganizationModal}
        setClose={() => closeModal('newOrganizationModal')}
      />
    </>
  );
};
